const enigmes = {
    enigme1: {
        title: "Chendo",
        coords: "96,424,184,360",
        shape: "rect",
        text: "Rester ici ne nous mènera à rien. <br> Il faut sortir et partir à leur recherche. (Prendre l'air)",
    },
    enigme2: {
        title: "Arloud",
        coords: "310,379,425,309",
        shape: "rect",
        text: "Espérer que Tsadkiel revienne et attendre ici est une perte de temps. <br> Finissons de nous préparer et partons à leur recherche. (N'oubliez pas les œufs et leur demi-effet dirait Tsadkiel)",
    },

    Enigme3: {
        title: "Thylanor",
        coords: "868,257,983,126",
        shape: "rect",
        text: "Utilisons ce temps pour trouver un plan. <br>Se hâter dans le désert sans préparation pourrait se révéler très dangereux. <br>Surtout que nous ne connaissons pas les environs.( il l'a lu dans le mot !)",
    },

    Enigme4: {
        title: " Gaelen",
        coords: "714,337,851,174",
        shape: "rect",
        text: "Grand Baryon ! Comment peuvent-ils être aussi inconscients ! <br>Jamais ils ne réfléchissent aux conséquences de leurs actes !?<br> Encore une fois, je vais devoir faire en sorte d’éviter un drame. (J'ai aussi, et il a un demi eu !)",
    },
    Enigme5: {
        title: " La rose jaune reviendra.",
        coords: "843,569,1010,672",
        shape: "rect",
        text: "De l’or noir suinte derrière une magnifique rose jaune du désert.<br> Une gravure dans la roche vous montre un quadrillage  de 15 x 5 carrés.<br> A côté est gravé en lettre grasse un K avec une flèche en direction du plafond<br>. Puis en dessous du quadrillage étrange sont notées les lettres T E S <br>dans un mélange de sable et de roche. Puis une signature :<br> Un bâton, 4 bâtons, puis de nouveau 4 bâtons barrés.",
    },
    Enigme6: {
        title: "44.",
        coords: "223, 559, 249, 578",
        shape: "rect",
        text: "&#9650; Premier &nbsp;&nbsp;<br>&#9660; Deuxième <br>&#9658; Troisième <br>&#9664; Quatrième"
    },
    Enigme7: {
        title: "81.",
        coords: "941, 60,989, 98",
        shape: "rect",
        text: "Un /sceau dans le temps"
    },

};
export default enigmes;